<app-header></app-header>
<div class="icf-wrap">

  <!-- ══════════════ HERO ══════════════ -->
  <section class="hero-section">
    <div class="hero-bg"></div>
    <div class="hero-overlay"></div>
    <div class="hero-center">
      <div class="pill-eyebrow">
        <span class="pill-dot"></span>
        ICF CREDENTIAL EXPLAINED
      </div>
      <h1>What is the <em>ICF</em> and<br>why does it <em>matter?</em></h1>
      <p class="hero-sub">
        The International Coaching Federation is the gold standard in professional coaching.
        This page explains ACC, PCC, and MCC in plain language — and shows exactly
        which NEXGEN Executive Coaching Academy program gets you there.
      </p>
      <div class="hero-btns">
        <a href="https://academy.nexgencoaches.com/live-session" target="_blank" rel="noopener noreferrer" class="btn-gold-solid">
          ATTEND FREE WEBINAR
        </a>
        <a href="https://nexgencoaches.com/programs/" target="_blank" rel="noopener noreferrer" class="btn-white-outline">
          EXPLORE PROGRAMS →
        </a>
      </div>
      <div class="hero-stats-strip">
        <div class="hs-item">
          <span class="hs-num">50,000+</span>
          <span class="hs-lbl">ICF Credentialed Coaches</span>
        </div>
        <div class="hs-item">
          <span class="hs-num">PCC</span>
          <span class="hs-lbl">Standard, all programs</span>
        </div>
        <div class="hs-item">
          <span class="hs-num">ICF</span>
          <span class="hs-lbl">ACC &amp; PCC pathways</span>
        </div>
      </div>
    </div>
  </section>

  <!-- ══════════════ WHAT IS ICF (cream) ══════════════ -->
  <section class="cream-section">
    <div class="cx">
      <p class="gold-eyebrow">THE FOUNDATION</p>
      <h2>If you're wondering what <em>the ICF is,</em><br>you're not alone.</h2>
      <p class="section-lead">
        These are the exact questions people ask when they discover coaching as a career.
        We built this page to answer all of them clearly.
      </p>

      <div class="accordion-rows">
        <div class="acc-row">
          <div class="acc-num">1</div>
          <div class="acc-divider"></div>
          <div class="acc-body">
            <strong>"What is the ICF?"</strong>
            <p>The International Coaching Federation is the main body people look to when they want to know if a coach is trained, tested, and working at a real professional standard. It is the most recognized coaching credential in the world.</p>
          </div>
          <div class="acc-result">
            <em>Your ICF credential shows clients and companies you took coaching seriously.</em>
          </div>
        </div>
        <div class="acc-row">
          <div class="acc-num">2</div>
          <div class="acc-divider"></div>
          <div class="acc-body">
            <strong>"What are ACC, PCC, and MCC?"</strong>
            <p>These are the three main ICF credentials. ACC is the entry level. PCC is advanced — most companies request PCC when hiring coaches. MCC is the highest level, held by very few coaches in the world.</p>
          </div>
          <div class="acc-result">
            <em>Most people start with ACC and grow into PCC over time.</em>
          </div>
        </div>
        <div class="acc-row">
          <div class="acc-num">3</div>
          <div class="acc-divider"></div>
          <div class="acc-body">
            <strong>"Why does the credential matter?"</strong>
            <p>An ICF credential is recognized in over 160 countries. It tells clients, corporations, and employers that you followed a rigorous, tested process and met a global standard of coaching skill.</p>
          </div>
          <div class="acc-result">
            <em>Your credential can take your practice anywhere in the world.</em>
          </div>
        </div>
        <div class="acc-row">
          <div class="acc-num">4</div>
          <div class="acc-divider"></div>
          <div class="acc-body">
            <strong>"How do I get an ICF credential?"</strong>
            <p>You complete accredited training hours, real coaching hours with clients, mentor coaching hours, and pass the ICF exam. The exact numbers depend on which credential you're pursuing — ACC or PCC.</p>
          </div>
          <div class="acc-result">
            <em>NEXGEN Executive Coaching Academy shows you exactly what to do at every step.</em>
          </div>
        </div>
      </div>

      <!-- inline CTA band -->
      <!-- <div class="inline-cta-band">
        <p>There's a simpler path. Start with a <em>free, no-pressure webinar.</em></p>
        <a href="https://academy.nexgencoaches.com/live-session" target="_blank" rel="noopener noreferrer" class="btn-gold-solid">Reserve My Spot</a>
      </div> -->
    </div>
  </section>

  <!-- ══════════════ THREE CREDENTIALS (white) ══════════════ -->
  <section class="white-section">
    <div class="cx">
      <p class="gold-eyebrow">THE THREE CREDENTIALS</p>
      <h2>ACC, PCC, and MCC —<br><em>explained simply.</em></h2>
      <p class="section-lead">The ICF has three main coaching credentials. Here is what each one requires and what it means for your career.</p>

      <div class="feature-table">
        <div class="ft-row ft-head-row">
          <div class="ft-num-col"></div>
          <div class="ft-divider-col"></div>
          <div class="ft-main-col"><span>Credential</span></div>
          <div class="ft-result-col"><span>Requirements</span></div>
        </div>

        <div class="ft-row featured-ft-row">
  <div class="ft-num-col"><span class="ft-num">01</span></div>
  <div class="ft-divider-col"><div class="ft-line gold-line"></div></div>
  <div class="ft-main-col">
    <div class="cred-pill-label acc-label">ACC <span class="most-req-tag">MOST POPULAR</span></div>
            <strong>Associate Certified Coach</strong>
            <p>ACC is where many coaches begin. It shows you finished training, practiced with real people, got mentor support, and passed the ICF exam. It is a strong first step for building a coaching business.</p>
            <div class="nexgen-path-tag gold-path-tag">→ NEXGEN Executive Coaching Academy Gold is your ACC pathway</div>
          </div>
          <div class="ft-result-col">
            <div class="req-list">
              <div class="req-line"><span class="req-arrow">→</span><strong>60 hours</strong> coach training</div>
              <div class="req-line"><span class="req-arrow">→</span><strong>100 hours</strong> coaching clients</div>
              <div class="req-line"><span class="req-arrow">→</span><strong>10 hours</strong> mentor coaching</div>
              <div class="req-line"><span class="req-arrow">→</span><strong>ICF exam</strong> knowledge test</div>
            </div>
          </div>
        </div>

        <div class="ft-row">
  <div class="ft-num-col"><span class="ft-num">02</span></div>
  <div class="ft-divider-col"><div class="ft-line"></div></div>
  <div class="ft-main-col">
    <div class="cred-pill-label pcc-label">PCC</div>
            <strong>Professional Certified Coach</strong>
            <p>PCC is a bigger step. It is often the credential companies want when they hire coaches. It shows deeper training, more coaching time, and stronger coaching skill.</p>
            <div class="nexgen-path-tag">→ NEXGEN Executive Coaching Academy Platinum is your PCC pathway</div>
          </div>
          <div class="ft-result-col">
            <div class="req-list">
              <div class="req-line"><span class="req-arrow">→</span><strong>125 hours</strong> coach training</div>
              <div class="req-line"><span class="req-arrow">→</span><strong>500 hours</strong> coaching clients</div>
              <div class="req-line"><span class="req-arrow">→</span><strong>10 hours</strong> mentor coaching</div>
              <div class="req-line"><span class="req-arrow">→</span><strong>Performance review</strong> live eval</div>
            </div>
          </div>
        </div>

        <div class="ft-row">
          <div class="ft-num-col"><span class="ft-num">03</span></div>
          <div class="ft-divider-col"><div class="ft-line"></div></div>
          <div class="ft-main-col">
            <div class="cred-pill-label mcc-label">MCC</div>
            <strong>Master Certified Coach</strong>
            <p>MCC is the top ICF credential. Very few coaches reach this level. It shows years of practice, deep skill, and true coaching mastery. Our lead faculty member, Lyssa deHart, holds the MCC.</p>
            <div class="nexgen-path-tag muted-path-tag">→ Lyssa deHart, our lead faculty, holds the MCC</div>
          </div>
          <div class="ft-result-col">
            <div class="req-list">
              <div class="req-line"><span class="req-arrow">→</span><strong>200 hours</strong> coach training</div>
              <div class="req-line"><span class="req-arrow">→</span><strong>2,500 hours</strong> coaching clients</div>
              <div class="req-line"><span class="req-arrow">→</span><strong>10 hours</strong> mentor coaching</div>
              <div class="req-line"><span class="req-arrow">→</span><strong>Advanced review</strong> highest standard</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ══════════════ HOW PATH WORKS (cream) ══════════════ -->
  <section class="cream-section">
    <div class="cx">
      <p class="gold-eyebrow">THE PATHWAY</p>
      <h2>How the ICF path <em>actually works.</em></h2>
      <p class="section-lead">
        This is the part that confuses most people. Here it is in simple steps.
      </p>

      <div class="accordion-rows">
        <div class="acc-row">
          <div class="acc-num">1</div>
          <div class="acc-divider"></div>
          <div class="acc-body">
            <strong>Pick your goal.</strong>
            <p>Most people start with ACC. If you want to go farther, you can grow into PCC later. NEXGEN Executive Coaching Academy supports both paths clearly — you always know what to do next.</p>
          </div>
          <div class="acc-result">
            <em>Know where you are going before you begin.</em>
          </div>
        </div>
        <div class="acc-row">
          <div class="acc-num">2</div>
          <div class="acc-divider"></div>
          <div class="acc-body">
            <strong>Finish the right training.</strong>
            <p>You need coach training from a school the ICF accepts. Level 1 is for ACC. Level 2 is for PCC. NEXGEN Executive Coaching Academy is ICF accredited at both levels.</p>
          </div>
          <div class="acc-result">
            <em>NEXGEN Executive Coaching Academy Gold is Level 1. NEXGEN Executive Coaching Academy Platinum is Level 2.</em>
          </div>
        </div>
        <div class="acc-row">
          <div class="acc-num">3</div>
          <div class="acc-divider"></div>
          <div class="acc-body">
            <strong>Coach real people and log hours.</strong>
            <p>You need real coaching hours. This is where most people get stuck. NEXGEN Executive Coaching Academy's Barter Coaching Platform connects you with peers to practice and log hours — no hunting alone.</p>
          </div>
          <div class="acc-result">
            <em>Hours requirement solved. Built into the program.</em>
          </div>
        </div>
        <div class="acc-row">
          <div class="acc-num">4</div>
          <div class="acc-divider"></div>
          <div class="acc-body">
            <strong>Get mentor support.</strong>
            <p>Ten hours of mentor coaching are required for all credentials. This is built directly into NEXGEN Executive Coaching Academy Gold and Platinum — not an extra cost, not something you figure out alone.</p>
          </div>
          <div class="acc-result">
            <em>Mentor coaching included in Gold and Platinum.</em>
          </div>
        </div>
        <div class="acc-row">
          <div class="acc-num">5</div>
          <div class="acc-divider"></div>
          <div class="acc-body">
            <strong>Pass the exam and apply.</strong>
            <p>The ICF exam checks that you understand the standard. Once you pass, you apply and become credentialed. You are ready to coach professionally and build your business.</p>
          </div>
          <div class="acc-result">
            <em>You graduate with a credential and a business plan.</em>
          </div>
        </div>
      </div>

      <!-- <div class="inline-cta-band">
        <p>There's a simpler path. Start with a <em>free, no-pressure webinar.</em></p>
        <a href="https://academy.nexgencoaches.com/live-session" target="_blank" rel="noopener noreferrer" class="btn-gold-solid">Reserve My Spot</a>
      </div> -->
    </div>
  </section>

  <!-- ══════════════ NEXGEN Executive Coaching Academy DIFFERENCE (white) ══════════════ -->
  <section class="white-section">
    <div class="cx">
      <p class="gold-eyebrow">THE NEXGEN Executive Coaching Academy DIFFERENCE</p>
      <h2>You don't want to feel stuck after<br>you <em>earn your certification.</em></h2>
      <p class="section-lead">At NEXGEN Executive Coaching Academy, we teach you how to become a coach and build your business.</p>

      <div class="feature-table">
        <div class="ft-row">
          <div class="ft-num-col"><span class="ft-num">01</span></div>
          <div class="ft-divider-col"><div class="ft-line"></div></div>
          <div class="ft-main-col">
            <strong>Be a Coach. Build a Business.</strong>
            <p>Our singular promise. We teach coaching excellence and how to attract clients, set pricing, and build a sustainable practice. No other program does both.</p>
          </div>
          <div class="ft-result-col">
            <div class="result-quote"><em>You graduate with a business plan — not just a certificate.</em></div>
          </div>
        </div>
        <div class="ft-row">
          <div class="ft-num-col"><span class="ft-num">02</span></div>
          <div class="ft-divider-col"><div class="ft-line"></div></div>
          <div class="ft-main-col">
            <strong>ICF — Finally Demystified</strong>
            <p>Clear explanation of credential levels. Structured path to ACC or PCC. Mentor coaching built in. No guesswork, no hidden steps — just a clear roadmap from where you are.</p>
          </div>
          <div class="ft-result-col">
            <div class="result-quote"><em>You understand exactly what to do and when to do it.</em></div>
          </div>
        </div>
        <div class="ft-row">
          <div class="ft-num-col"><span class="ft-num">03</span></div>
          <div class="ft-divider-col"><div class="ft-line"></div></div>
          <div class="ft-main-col">
            <strong>Designed for Working Professionals</strong>
            <p>Start anytime, go at your pace. Day, evening and weekend live sessions. AI-powered platform available 24/7. Built specifically for people who cannot stop their lives.</p>
          </div>
          <div class="ft-result-col">
            <div class="result-quote"><em>You do not have to pause your career to build your next chapter.</em></div>
          </div>
        </div>
        <div class="ft-row">
          <div class="ft-num-col"><span class="ft-num">04</span></div>
          <div class="ft-divider-col"><div class="ft-line"></div></div>
          <div class="ft-main-col">
            <strong>Practice Hours — Solved</strong>
            <p>Our exclusive Barter Coaching Platform connects you with peers to log required ICF hours through real coaching conversations. No more hunting for clients alone.</p>
          </div>
          <div class="ft-result-col">
            <div class="result-quote"><em>You hit your ICF hour requirements without the stress.</em></div>
          </div>
        </div>
        <div class="ft-row">
          <div class="ft-num-col"><span class="ft-num">05</span></div>
          <div class="ft-divider-col"><div class="ft-line"></div></div>
          <div class="ft-main-col">
            <strong>Open to All Coaches</strong>
            <p>Wherever you trained, whatever school you attended — NEXGEN Executive Coaching Academy is for you. We believe great coaches come from everywhere, and we are building a remarkable global community.</p>
          </div>
          <div class="ft-result-col">
            <div class="result-quote"><em>You belong here, regardless of your background.</em></div>
          </div>
        </div>
        <div class="ft-row">
          <div class="ft-num-col"><span class="ft-num">06</span></div>
          <div class="ft-divider-col"><div class="ft-line"></div></div>
          <div class="ft-main-col">
            <strong>PCC-Level Quality from Day One</strong>
            <p>Every program — Silver, Gold, or Platinum — is taught at PCC standard. Neuroscience-informed, emotionally intelligent, grounded in the Sticky Outcomes framework.</p>
          </div>
          <div class="ft-result-col">
            <div class="result-quote"><em>You start with quality. You do not earn it over time.</em></div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ══════════════ PROGRAMS (cream) ══════════════ -->
  <section class="cream-section programs-sec">
    <div class="cx">
      <div class="prog-header-row">
        <div class="prog-header-left">
          <p class="gold-eyebrow">CERTIFICATION PROGRAMS</p>
          <h2>Choose your <em>pathway.</em></h2>
        </div>
        <div class="prog-header-right">
          <p>Three tiers. Start where you are. Upgrade anytime. Rolling enrollment — you begin when you're ready.</p>
        </div>
      </div>

      <div class="prog-cards">
        <!-- SILVER -->
        <div class="prog-card">
          <div class="pc-tier-label silver-lbl">SILVER</div>
          <h3>Certificate</h3>
          <p class="pc-credential-sub">NON-ICF · UPGRADEABLE ANYTIME</p>
          <div class="pc-price">$9,995</div>
          <p class="pc-price-note">One-time · Financing available</p>
          <div class="pc-divider"></div>
          <ul class="pc-features">
            <li><span class="pc-arrow">→</span> 38 EDUCATION HOURS</li>
            <li><span class="pc-arrow">→</span> LIVE &amp; ASYNC INSTRUCTION</li>
            <li><span class="pc-arrow">→</span> 2-DAY LIVE INTENSIVE SEMINAR</li>
            <li><span class="pc-arrow">→</span> 2–3 MONTHS, SELF-PACED</li>
            <li><span class="pc-arrow">→</span> AI-POWERED LMS PLATFORM</li>
            <li><span class="pc-arrow">→</span> STICKY OUTCOMES BOOK</li>
            <li><span class="pc-arrow">→</span> ACCESS TO COACHING COMMUNITY</li>
            <li><span class="pc-arrow">→</span> NEXGEN Executive Coaching Academy CERTIFICATE</li>
          </ul>
          <a href="https://nexgencoaches.com/programs/" target="_blank" rel="noopener noreferrer" class="pc-btn pc-btn-outline">START WITH SILVER</a>
          <p class="pc-upgrade">↑ Upgrade to Gold or Platinum anytime</p>
        </div>

        <!-- GOLD -->
        <div class="prog-card prog-card-featured">
          <div class="pc-most-popular">MOST POPULAR</div>
          <div class="pc-tier-label gold-lbl">GOLD</div>
          <h3>ACC</h3>
          <p class="pc-credential-sub pc-gold-sub">ICF LEVEL 1 · ACC CREDENTIAL READY</p>
          <div class="pc-price">$11,995</div>
          <p class="pc-price-note">One-time · Financing available</p>
          <div class="pc-divider pc-divider-gold"></div>
          <p class="pc-level-tag">LEVEL 1</p>
          <ul class="pc-features">
            <li><span class="pc-arrow">→</span> 69 ICF EDUCATION HOURS</li>
            <li><span class="pc-arrow">→</span> 10 HOURS MENTOR COACHING</li>
            <li><span class="pc-arrow">→</span> 2-DAY LIVE INTENSIVE SEMINAR</li>
            <li><span class="pc-arrow">→</span> 5–6 MONTH COMPLETION</li>
            <li><span class="pc-arrow">→</span> AI-POWERED LMS PLATFORM</li>
            <li><span class="pc-arrow">→</span> STICKY OUTCOMES BOOK</li>
            <li><span class="pc-arrow">→</span> RAENOTES DEVELOPMENTAL EVALS</li>
            <li><span class="pc-arrow">→</span> BARTER COACHING PLATFORM</li>
            <li><span class="pc-arrow">→</span> ACCESS TO COACHING COMMUNITY</li>
            <li><span class="pc-arrow">→</span> 1-YEAR ICF MEMBERSHIP</li>
          </ul>
          <a href="https://nexgencoaches.com/programs/" target="_blank" rel="noopener noreferrer" class="pc-btn pc-btn-outline">START WITH GOLD</a>
          <p class="pc-upgrade">↑ Upgrade to Platinum anytime</p>
        </div>

        <!-- PLATINUM -->
        <div class="prog-card">
          <div class="pc-tier-label platinum-lbl">PLATINUM</div>
          <h3>PCC</h3>
          <p class="pc-credential-sub">ICF LEVEL 2 · PCC CREDENTIAL READY</p>
          <div class="pc-price">$13,995</div>
          <p class="pc-price-note">One-time · Financing available</p>
          <div class="pc-divider"></div>
          <p class="pc-level-tag">LEVEL 2</p>
          <ul class="pc-features">
            <li><span class="pc-arrow">→</span> 125 ICF EDUCATION HOURS</li>
            <li><span class="pc-arrow">→</span> 10 HOURS MENTOR COACHING</li>
            <li><span class="pc-arrow">→</span> 2-DAY LIVE INTENSIVE SEMINAR</li>
            <li><span class="pc-arrow">→</span> 6–12 MONTHS COMPLETION</li>
            <li><span class="pc-arrow">→</span> AI-POWERED LMS PLATFORM</li>
            <li><span class="pc-arrow">→</span> STICKY OUTCOMES BOOK</li>
            <li><span class="pc-arrow">→</span> RAENOTES DEVELOPMENTAL EVALS</li>
            <li><span class="pc-arrow">→</span> ADVANCED ELECTIVE COURSES</li>
            <li><span class="pc-arrow">→</span> BARTER COACHING PLATFORM</li>
            <li><span class="pc-arrow">→</span> ACCESS TO COACHING COMMUNITY</li>
            <li><span class="pc-arrow">→</span> 1-YEAR ICF MEMBERSHIP</li>
          </ul>
          <a href="https://nexgencoaches.com/programs/" target="_blank" rel="noopener noreferrer" class="pc-btn pc-btn-outline">START WITH PLATINUM</a>
          <p class="pc-upgrade">↑ Our highest level of mastery</p>
        </div>
      </div>
    </div>
  </section>

  <!-- ══════════════ FAQ (white) ══════════════ -->
  <section class="white-section">
    <div class="cx">
      <p class="gold-eyebrow">COMMON QUESTIONS</p>
      <h2>Frequently asked <em>questions.</em></h2>
      <p class="section-lead">These are the questions people ask most when trying to understand the ICF path.</p>

      <div class="accordion-rows">
        <div class="acc-row">
          <div class="acc-num">1</div>
          <div class="acc-divider"></div>
          <div class="acc-body">
            <strong>What is ICF coaching certification?</strong>
            <p>ICF coaching certification is a professional credential path from the International Coaching Federation. The three main credentials are ACC, PCC, and MCC — each requiring more training and hours than the last.</p>
          </div>
          <div class="acc-result">
            <em>The most recognized coaching credential in the world.</em>
          </div>
        </div>
        <div class="acc-row">
          <div class="acc-num">2</div>
          <div class="acc-divider"></div>
          <div class="acc-body">
            <strong>What is the difference between ACC and PCC?</strong>
            <p>ACC requires 60 training hours and 100 coaching hours. PCC requires 125 training hours and 500 coaching hours. PCC is more advanced and often what companies request when hiring coaches.</p>
          </div>
          <div class="acc-result">
            <em>Most people start with ACC and grow into PCC.</em>
          </div>
        </div>
        <div class="acc-row">
          <div class="acc-num">3</div>
          <div class="acc-divider"></div>
          <div class="acc-body">
            <strong>What is the difference between Level 1 and Level 2?</strong>
            <p>Level 1 is the ICF-accredited education path built for ACC. Level 2 is the larger path built for PCC. NEXGEN Executive Coaching Academy Gold is Level 1. NEXGEN Executive Coaching Academy Platinum is Level 2.</p>
          </div>
          <div class="acc-result">
            <em>NEXGEN Executive Coaching Academy Gold = Level 1. NEXGEN Executive Coaching Academy Platinum = Level 2.</em>
          </div>
        </div>
        <div class="acc-row">
          <div class="acc-num">4</div>
          <div class="acc-divider"></div>
          <div class="acc-body">
            <strong>Does NEXGEN Executive Coaching Academy include mentor coaching?</strong>
            <p>Yes. NEXGEN Executive Coaching Academy Gold and Platinum both include the required 10 hours of mentor coaching as part of the program. It is not an add-on cost — it is built in.</p>
          </div>
          <div class="acc-result">
            <em>Mentor coaching is included — not extra.</em>
          </div>
        </div>
        <div class="acc-row">
          <div class="acc-num">5</div>
          <div class="acc-divider"></div>
          <div class="acc-body">
            <strong>How do I log my coaching hours?</strong>
            <p>NEXGEN Executive Coaching Academy's Barter Coaching Platform connects you with other coaches to practice real sessions and log your required ICF hours. You coach someone, and they coach you back. Hours solved.</p>
          </div>
          <div class="acc-result">
            <em>No hunting alone. The platform does the matching.</em>
          </div>
        </div>
        <div class="acc-row">
          <div class="acc-num">6</div>
          <div class="acc-divider"></div>
          <div class="acc-body">
            <strong>Is Silver part of the ICF path?</strong>
            <p>Silver is a non-ICF certificate option designed as a starting point. You can upgrade to Gold or Platinum later and your learning progress carries forward.</p>
          </div>
          <div class="acc-result">
            <em>Start with Silver. Upgrade when you're ready.</em>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ══════════════ FINAL CTA (navy) ══════════════ -->
  <section class="final-cta-section">
    <div class="cx fcs-inner">
      <div class="fcs-left">
        <h2>Ready to begin?</h2>
        <p>Come to a free webinar and get clear on your next step. No pressure, no sales pitch — just honest answers.</p>
      </div>
      <div class="fcs-right">
        <a href="https://academy.nexgencoaches.com/live-session" target="_blank" rel="noopener noreferrer" class="btn-gold-solid btn-lg">
          RESERVE FREE SPOT
        </a>
        <a href="https://nexgencoaches.com/programs/" target="_blank" rel="noopener noreferrer" class="btn-white-outline">
          VIEW ALL PROGRAMS →
        </a>
      </div>
    </div>
  </section>

</div>
<app-bottomside></app-bottomside>